import { getTextField } from '@lender/utils';
import LexicalParser from 'app/services/formula/parser/lexicalParser';
import SyntaxParser, { syntaxParser } from 'app/services/formula/parser/syntaxParser';

import { cleanFormattedExpression } from 'utils/expressions';

export const getExpressionField = ({
  isRequired = true,
  schemaParams,
  isOnlyBooleanAllowed,
  isOnlyNumericAllowed,
  isNewExpressionsParsingLogicEnabled = false,
  isPreserved,
}) =>
  getTextField({ isRequired }).test({
    name: 'expression-field',
    test(expression) {
      /* An expression the user hasn't edited (its text still matches the stored original) is
         persisted verbatim from the source map on save, so re-parsing its lossy text->tree
         round-trip here would falsely reject a valid stored tree — e.g. ANY/aggregate iterators
         the text renderer drops (DEV-3494 / STP-272). Skip validation for those; only re-validate
         what the user actually typed. */
      if (isPreserved?.(expression)) {
        return true;
      }

      const lexicalParser = new LexicalParser(schemaParams);

      const tokens = lexicalParser.parse(cleanFormattedExpression(expression));

      if (isNewExpressionsParsingLogicEnabled) {
        const newSyntaxParser = new SyntaxParser(schemaParams);

        const { error } = newSyntaxParser.parse({
          tokens,
          isOnlyBooleanAllowed,
          isOnlyNumericAllowed,
        });

        return error ? this.createError({ message: error.message }) : true;
      }

      const { error } = syntaxParser({
        tokens,
        schemaParams,
        isOnlyBooleanAllowed,
        isOnlyNumericAllowed,
      });

      return error ? this.createError({ message: error.message }) : true;
    },
  });
